import React from 'react';

var OverflowMenu = function OverflowMenu(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(90 12 6)",
    cx: "12",
    cy: "6",
    r: "2"
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(90 12 12)",
    cx: "12",
    cy: "12",
    r: "2"
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(90 12 18)",
    cx: "12",
    cy: "18",
    r: "2"
  })));
};

OverflowMenu.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { OverflowMenu as icon };
export default iconHandler(OverflowMenu);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/OverflowMenu.js
// module id = 618
// module chunks = 0